<template>
  <TopListPanel
    :isArchiveEnabled="isArchiveEnabled"
    :isFilterEnabled="isFilterEnabled"
    :isFilterSetted="isFilterSetted"
    :items="items"
    :is-button-disabled="isDenied"
    searchPlaceholder="Поиск по названию"
    buttonLabel="Создать сегмент"
    routeCreate="segmentCreate"
    @toggle-archive="toggleArchiveParent"
    @set-common-filter="setCommonFilterParent"
    @toggle-filter="toggleFilterParent"
  ></TopListPanel>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { useAuthStore } from "@/store/auth/login";

import TopListPanel from "@/widgets/panels/TopListEntitiesPanel.vue";

const authStore = useAuthStore();

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["segment:edit", "system:edit"]);
});

defineProps<{
  isArchiveEnabled: boolean;
  isFilterEnabled: boolean;
  isFilterSetted: boolean;
}>();
const emit = defineEmits(["setCommonFilter", "toggleArchive", "toggleFilter"]);

const toggleArchiveParent = () => {
  emit("toggleArchive");
};

const setCommonFilterParent = (value: string) => {
  emit("setCommonFilter", value);
};

const toggleFilterParent = () => {
  emit("toggleFilter");
};

const items = ref([
  { label: "Сегмент", archive: "both" },
  { label: "Список сегментов", archive: "both", reload: true },
  { label: "Архив", archive: "archive" },
]);
</script>
